import { destroyImage } from "@/libs/image"
import { writable } from "svelte/store"
import type { CaptureMetadata } from "../api"

export type ImageCapture = {
  image: HTMLImageElement
  metadata: Partial<CaptureMetadata>
}

/** Captured image candidates */
export const captures = {
  ...writable<ImageCapture[]>([]),

  push(capture: ImageCapture) {
    this.update((captures) => [...captures, capture])
  },

  clear() {
    this.update((captures) => {
      for (const capture of captures) destroyImage(capture.image)

      return []
    })
  },
}
